exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer[data-v-2e26a753]{background-color:#fcd599}.footer .footer-head[data-v-2e26a753]{background-color:#f4ab7b;border-top:2px solid #f19060;border-bottom:2px solid #f19060}.footer .footer-nav .nav-list .nav-list-item a[data-v-2e26a753]{color:#333;font-size:.7rem}.footer .footer-nav .nav-list.nav-list-lang[data-v-2e26a753]{width:80%;border:2px solid #b9b2a6}@media (min-width:576px){.footer .footer-nav .nav-list.nav-list-lang[data-v-2e26a753]{width:60%}}@media (min-width:768px){.footer .footer-nav .nav-list.nav-list-lang[data-v-2e26a753]{width:40%}}@media (min-width:992px){.footer .footer-nav .nav-list.nav-list-lang[data-v-2e26a753]{width:90%}}.footer .footer-nav .nav-list.nav-list-lang li[data-v-2e26a753]{line-height:1.5rem}.footer .footer-nav .nav-list-lang-head i[data-v-2e26a753]{font-size:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2e26a753&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/GuestFooter.vue
// module id = 497
// module chunks = 0